/*
 * --------------------------------------
 * Copyright (c) 2020 BetterCapital.US
 * --------------------------------------
 */

import {
  GET_ASSET_CHECKLIST_SUCCESS,
  // GET_ASSET_CHECKLIST_FAILURE,
} from "../actions/actionTypes";

const initialState = {
  checklist: {},
};

export default function (state = initialState, action) {
  switch (action.type) {
    case GET_ASSET_CHECKLIST_SUCCESS:
      return {
        checklist: action.payload.checklist,
      };

    // case GET_ASSET_CHECKLIST_FAILURE:
    // return {
    //   slug: action.payload
    // }

    default:
      return state;
  }
}
